module.exports = {
  footerText: 'Copyright Combase © 2019',
}
